import { thoughtActivityCopy } from './thoughtActivityKinds'

export function detailSteps(details, streaming) {
  const copy = thoughtActivityCopy('thinking')
  return details
    .map((text) => String(text ?? '').trim())
    .filter(Boolean)
    .map((body, index, items) => ({
      kind: 'detail',
      id: `detail-${index}`,
      category: 'thinking',
      title: copy.title,
      body,
      running: streaming && index === items.length - 1,
    }))
}
